import { types } from 'mobx-state-tree';
import { MatchTrackerType } from '../dtos/apiLiveEventsDtos';

export const MatchTrackerInApi = types.model({
    id: types.string,
    type: types.number // MatchTrackerType
}).actions(self => {
    const setData = (type: MatchTrackerType, id: string): void => {
        self.id = id;
        self.type = type;
    }

    return {
        setData
    }
});;
